export default __webpack_public_path__ + "static/media/include_2_male@2x.d83c52b1.jpg";